<template>
  <div class="rank-wrapbox" :class="{ 'rank-preview-box': isSubscribe }">
    <div
      v-if="info.inSwitch == 1 || info.rewardSwitch == 1"
      class="rank-previewbox"
      :style="rankPreviewboxSty"
    >
      <!-- 顶部区域 -->
      <header class="ranking-title">
        <div class="rank-menu">
          <span
            v-if="info.inSwitch == 1"
            :class="{ active: activeTab === 'invite' }"
            @click="changeTab('invite')"
          >
            {{ $t('nav.nav_1032') }}
            <i
              class="my_invite_detail"
              v-if="inviteCardInfo.invite_detail_switch"
              @click.stop="inviteDetailsVisible = true"
            >
              {{ $t('nav.nav_1060') }}
            </i>
          </span>
          <span
            v-if="info.rewardSwitch == 1"
            :class="{ active: activeTab === 'award' }"
            @click="changeTab('award')"
          >
            {{ $t('nav.nav_1033') }}
          </span>
        </div>
        <div class="rank-rule" @click="changeRulesShow" v-show="info.inContent">
          {{ activeTab == 'invite' ? $t('nav.nav_1034') : $t('nav.nav_1035') }}
          <span
            class="vh-iconfont rank-icon"
            :class="[showRules ? 'vh-line-arrow-up' : 'vh-line-arrow-down']"
          ></span>
        </div>
      </header>

      <!-- 规则浮窗 -->
      <section v-show="showRules" class="ranking-box watch-area">
        <div v-show="activeTab === 'invite'" class="rank-con" v-html="info.inContent"></div>
        <div v-show="activeTab === 'invite' && !info.inContent" class="rank-con center">
          {{ $t('nav.nav_1036') }}
        </div>
        <div
          v-show="activeTab === 'award' && info.rewardContent"
          class="rank-con"
          v-html="info.rewardContent"
        ></div>
        <div v-show="activeTab === 'award' && !info.rewardContent" class="rank-con center">
          {{ $t('nav.nav_1036') }}
        </div>
      </section>

      <!-- 正文区域 -->
      <main
        class="rank-band"
        v-loading="loading"
        :element-loading-text="$t('host.k_555001')"
        element-loading-background="rgba(0,0,0,0)"
      >
        <!-- 邀请榜 -->
        <section
          v-show="activeTab === 'invite'"
          class="band-list"
          :class="{ noData: inviteRankList.length == 0 }"
        >
          <template v-if="inviteRankList.length > 0">
            <div v-for="(item, index) in inviteRankList" :key="index" class="rank-item">
              <RankItemWatch :item="item" />
            </div>
            <div class="rank-list-more">
              <div v-if="!pageLock" class="loading-bottom">
                <span class="load-icon"></span>
                {{ bottomText }}
              </div>
              <template v-else-if="finished">
                <span v-if="pageConfig.total >= maxTotal && inviteRankList.length >= maxTotal">
                  {{ $t('common.common_1040', { n: 200 }) }}
                </span>
                <span v-else>{{ $t('nav.nav_1043') }}</span>
              </template>
            </div>
          </template>
          <template v-else-if="!loading">
            <img
              class="default-icon"
              :src="
                isMeetingColor
                  ? require('../assets/imgs/empty-pay.png')
                  : require('../assets/imgs/empty-pay-default.png')
              "
              alt=""
            />
            <span class="default-tip">{{ $t('nav.nav_1040') }}</span>
          </template>
        </section>

        <!-- 打赏榜 -->
        <section v-show="activeTab == 'award'" class="band-list">
          <template v-if="awardRankList.length > 0">
            <div v-for="(item, index) in awardRankList" :key="index" class="rank-item">
              <img
                v-if="index < 3"
                class="rank-num"
                :src="index == 0 ? bangdan1 : index == 1 ? bangdan2 : bangdan3"
                alt=""
              />
              <span v-else class="rank-num">{{ index + 1 }}</span>
              <div v-if="index < 3" :class="['top-three', `top-three-${index + 1}`]">
                <div class="rank-num-wrap">
                  <img :src="item.avatar" alt="" />
                </div>
              </div>
              <img v-else class="avatar" :src="item.avatar" alt="" />
              <span class="nickname">{{ item.nickname | overHidden(8) }}</span>
              <span class="num">
                <i18n path="interact_tools.interact_tools_1073">
                  <span class="n" place="n">¥{{ item.reward_amount | filterAmount }}</span>
                </i18n>
              </span>
            </div>
            <div
              v-if="showBottom && awardRankList.length >= awardPage.total"
              class="loading-bottom"
            >
              <span class="load-icon"></span>
              {{ bottomText }}
            </div>
          </template>
          <template v-else-if="!loading">
            <img
              class="default-icon"
              :src="
                isMeetingColor
                  ? require('../assets/imgs/empty-reward.png')
                  : require('../assets/imgs/empty-reward-default.png')
              "
              alt
            />
            <span class="default-tip">{{ $t('nav.nav_1041') }}</span>
          </template>
        </section>
      </main>

      <!-- 邀请观看 -->
      <div class="self-rank" v-if="ownerData && showInvite && !isEmbed">
        <RankItemWatch
          class="ma"
          :item="ownerData"
          :isMe="true"
          @viewDetails="inviteDetailsVisible = true"
          @doRowClick="handleDoMyInvite"
        />
      </div>
      <inviteDetails
        v-if="inviteDetailsVisible"
        :visible.sync="inviteDetailsVisible"
        :isCanDownload="!!inviteCardInfo.self_download_switch"
      />
    </div>
  </div>
</template>

<script>
  import {
    useCustomMenuServer,
    useUserServer,
    useInviteServer,
    useRoomBaseServer
  } from 'middle-domain';
  import { getDefaultAvatar } from '@/app-shared/utils/ossImgConfig';
  import RankItemWatch from './invite-rank/rank-item.vue';
  import tidCenter from '@/app-shared/utils/tidCenter.js';
  import '@vhcl/invitation-card/dist/css/index.css';

  export default {
    name: 'component-rank',
    components: {
      RankItemWatch,
      inviteDetails: () => import('./invite-rank/invite-details.vue')
    },
    props: {
      info: {
        required: false
      }
    },
    data() {
      return {
        bangdan1: require('../assets/imgs/bangdan-1.png'),
        bangdan2: require('../assets/imgs/bangdan-2.png'),
        bangdan3: require('../assets/imgs/bangdan-3.png'),
        avatar: getDefaultAvatar(),

        loading: false,
        pageLock: false,
        scrollLock: false,
        showBottom: false,
        showRules: false,
        bottomText: '',

        // 邀请榜
        finished: false,
        activeTab: 'invite',
        inviteRankList: [],
        maxTotal: 200,
        pageConfig: {
          page: 0,
          limit: 200,
          total: 0
        },
        ownerData: {
          rank_no: 0,
          nick_name: '--',
          num: 0
        },
        // 打赏
        awardRankList: [],
        awardPage: {
          pos: 0,
          limit: 10,
          total: 0
        },
        inviteDetailsVisible: false,
        inviteCardInfo: {}
      };
    },
    computed: {
      rankPreviewboxSty() {
        if (this.isSubscribe) {
          return {
            height: !this.inviteRankList || this.inviteRankList.length < 6 ? '370px' : '600px'
          };
        }
        return '';
      },
      isSubscribe() {
        return this.$domainStore.state.roomBaseServer.watchInitData.status == 'subscribe';
      },
      /**
       * 是否后台开启邀请卡功能
       */
      showInvite() {
        return this.$domainStore.state.roomBaseServer.inviteCard.status == 1;
      },
      isEmbed() {
        return this.$domainStore.state.roomBaseServer.embedObj.embed;
      },
      watchInitData() {
        return this.$domainStore.state.roomBaseServer.watchInitData;
      },
      joinInfo() {
        return this.$domainStore.state.roomBaseServer.watchInitData?.join_info;
      },
      // 是否是cms嵌入或者大会模式
      isMeetingColor() {
        return (
          this.$domainStore.state.roomBaseServer.isCms == 1 ||
          this.$domainStore.state.roomBaseServer.skinInfo.skin_json_pc?.style == 4
        );
      }
    },
    watch: {
      info: function (newVal) {
        if (newVal.inSwitch == 0 && this.activeTab === 'invite') {
          this.activeTab = 'award';
        } else if (newVal.rewardSwitch == 1 && this.activeTab === 'award') {
          this.activeTab = 'invite';
        }
      }
    },
    beforeCreate() {
      this.customMenuServer = useCustomMenuServer();
      this.userServer = useUserServer();
      this.inviteServer = useInviteServer();
      this.roomBaseServer = useRoomBaseServer();
    },
    mounted() {
      this.loading = true;
      if (this.info.inSwitch == 1) {
        this.activeTab = 'invite';
        this.getInviteRankList();
      } else if (this.info.rewardSwitch == 1) {
        this.activeTab = 'award';
        this.getAwardRankList();
      }
      if (this.showInvite) {
        this.getInviteInfo();
      }
      this.listenEvents();
    },
    methods: {
      async listenEvents() {
        await this.$nextTick();
        const wrap = document.querySelector('.rank-band');
        if (!wrap) return;
        wrap.addEventListener('scroll', e => {
          if (this.scrollLock) return;
          const clientHeight = e.target.clientHeight;
          const scrollHeight = e.target.scrollHeight;
          const scrollTop = e.target.scrollTop;
          if (clientHeight + scrollTop >= scrollHeight) {
            if (this.pageTimer) {
              clearTimeout(this.pageTimer);
              this.pageTimer = null;
            }
            this.scrollLock = true;
            this.pageTimer = setTimeout(() => {
              if (this.activeTab === 'invite') {
                // 邀请排行
                if (this.finished) return;
                this.getInviteRankList();
              } else {
                if (this.awardPage.pos >= this.awardPage.total) return;
                this.getAwardRankList();
              }
            }, 300);
          }
        });
      },
      async changeTab(tab = 'invite') {
        this.loading = true;
        this.activeTab = tab;

        this.pageLock = false;
        this.showBottom = false;
        this.scrollLock = false;

        if (tab === 'invite') {
          this.pageConfig = {
            page: 0,
            limit: 200,
            total: 0
          };
          this.inviteRankList = [];
          await this.getInviteRankList();
        }

        if (tab === 'award') {
          this.awardPage = {
            pos: 0,
            limit: 10,
            total: 0
          };
          this.awardRankList = [];
          await this.getAwardRankList();
        }

        // this.loading = false;
      },
      /**
       * 获取邀请列表
       */
      async getInviteRankList() {
        if (this.pageLock) return;
        this.pageLock = true;
        this.showBottom = true;
        this.bottomText = this.$t('common.common_1001');

        this.pageConfig.page++;
        let inviteId; // 邀请人id
        let inviteIdType; // 邀请人id类型
        try {
          // 获取用户登录信息
          const webinarId = this.watchInitData.webinar.id;
          const subjectId = sessionStorage.getItem('subjectId');
          const tid = await tidCenter.getTid(webinarId, subjectId);
          if (tid) {
            if (tid.startsWith('visit_')) {
              inviteId = tid.substring(6);
              inviteIdType = 2; //游客
            } else {
              inviteId = tid;
              inviteIdType = 1;
            }
          } else {
            // 获取用户登录信息
            const token = sessionStorage.getItem('token');
            if (token) {
              // 邀请卡已登录
              inviteId = this.userServer.state.userInfo?.user_id;
              inviteIdType = 1; // 观看端只能是c端用户
            }
          }
        } catch {}

        if (!inviteId) {
          // 如果用户未登录，则取游客id
          inviteId = this.watchInitData.visitor_id;
          inviteIdType = 2;
        }

        try {
          const params = {
            pos: (this.pageConfig.page - 1) * this.pageConfig.limit,
            limit: this.pageConfig.limit,
            source_id: this.watchInitData.webinar.id,
            source_type: 1, //数据来源id 类型 1.活动 2.落地页
            invite_id: inviteId,
            invite_id_type: inviteIdType
          };
          const res = await this.customMenuServer.getInviteTopList(params);
          if (res.code == 200 && res.data) {
            this.pageConfig.total = res.data.total || 0;
            let maxTotal = res.data.total || 0;
            if (this.pageConfig.total >= this.maxTotal) {
              // 总条数大于或等于200条，最多查询200条
              maxTotal = this.maxTotal;
            } else if (this.pageConfig.total < this.maxTotal) {
              // 总条数小于200条，按照200条去查询
              maxTotal = this.pageConfig.total;
            }
            if (this.pageConfig.page == 1 && this.pageConfig.total <= 0) {
              // 第一页加载没数据，停止内容
              this.pageLock = true;
              this.finished = true;
            }
            let list = res.data.list || [];
            let len = this.inviteRankList.length;
            list = res.data.list.map(item => {
              item.rank_no = len + item.position;
              return item;
            });

            this.ownerData = Object.assign({ rank_no: res.data.my.position }, res.data.my);

            this.inviteRankList = this.inviteRankList.concat(list);

            if (this.inviteRankList.length >= maxTotal) {
              this.pageLock = true;
              this.finished = true;
            } else {
              this.pageLock = false;
            }
          }
          this.scrollLock = false;

          return true;
        } catch (ex) {
          this.loading = false;
        } finally {
          this.loading = false;
        }
      },
      /**
       * 获取打赏列表
       */
      async getAwardRankList() {
        if (this.pageLock) return;
        this.pageLock = true;
        this.showBottom = true;
        this.bottomText = this.$t('host.k_555001');

        const res = await this.customMenuServer.getAwardList({
          room_id: this.watchInitData.interact.room_id,
          offset: parseInt(this.awardPage.pos),
          limit: 10
        });

        if (res.code == 200 && res.data) {
          const list = res.data.list.map(item => {
            if (!item.avatar) {
              item.avatar = this.avatar;
            }
            return item;
          });
          const data = this.awardRankList;
          this.awardPage = {
            pos: res.data.offset + 10,
            limit: 10,
            total: res.data.total
          };
          this.awardRankList = data.concat(list);
        }
        this.scrollLock = false;

        this.clearBottomInfo();
        this.loading = false;
        return true;
      },

      handleDoMyInvite() {
        this.$emit('send', 'emitOpenShareDialog', 4); // 呼出分享弹窗(4-邀请卡)
      },

      changeRulesShow() {
        this.showRules = !this.showRules;
      },

      clearBottomInfo() {
        this.pageLock = false;
        const awardOver = this.awardPage.pos + this.awardPage.limit >= this.awardPage.total;
        if (awardOver) {
          this.bottomText = '';
          this.showBottom = false;
        }
      },
      async getInviteInfo() {
        const { watchInitData } = this.roomBaseServer.state;
        // 从服务端获取
        let inviteId; // 邀请人id
        let inviteIdType; // 邀请人id类型
        try {
          const webinarId = watchInitData.webinar.id;
          const subjectId = sessionStorage.getItem('subjectId');
          const tid = await tidCenter.getTid(webinarId, subjectId);
          if (tid) {
            if (tid.startsWith('visit_')) {
              inviteId = tid.substring(6);
              inviteIdType = 2; //游客
            } else {
              inviteId = tid;
              inviteIdType = 1;
            }
          } else {
            const token = sessionStorage.getItem('token');
            if (token) {
              // 邀请卡已登录
              inviteId = this.userServer.state.userInfo?.user_id;
              inviteIdType = 1;
            }
          }
        } catch {}
        if (!inviteId) {
          // 如果用户未登录，则取游客id
          inviteId = watchInitData.visitor_id;
          inviteIdType = 2;
        }
        const reqData = {
          source_id: watchInitData?.webinar?.id, // 数据来源id
          source_type: 1, // 数据来源id 类型 1.活动 2.落地页
          language_type: 0, // 语言类型  0.中文  1.英文
          invite_id: inviteId, // 邀请人id
          channel: this.$route.query.channel, //channel
          invite_id_type: inviteIdType, // 邀请人id类型  1.C端用户id 2.游客id 3.B端用户
          business_uid: watchInitData?.webinar.userinfo.user_id // b端用户id
        };
        try {
          // 调用接口获取相关数据
          const res = await this.inviteServer.createInvite(reqData);
          if (res && res.code === 200) {
            this.inviteCardInfo = res.data;
          }
        } catch (error) {}
      }
    }
  };
</script>

<style lang="less" scoped>
  .rank-wrapbox {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    height: 100%;
  }
  .rank-preview-box {
    width: 480px;
    margin: 0px auto 20px;
    border-radius: 4px;
    border: 1px solid #444444;
    box-sizing: border-box;
    padding: 18px 24px;
    .rank-previewbox .ranking-box {
      top: 44px;
    }
  }
  .rank-previewbox {
    height: 100%;
    overflow: hidden;

    .ranking-title {
      font-size: 14px;
      color: var(--theme-tab-content-rank-title-font);
      line-height: 20px;
      height: 20px;
      position: relative;

      .rank-menu {
        padding-left: 24px;
        text-align: left;
        span {
          display: inline-block;
          height: 20px;
          line-height: 20px;
        }
      }
      span {
        color: @font-dark-low;
        &:hover {
          cursor: pointer;
        }
        &.active {
          // width: 42px;
          // height: 16px;
          font-size: 14px;
          font-weight: 400;
          color: var(--theme-tab-content-rank-title-font);
          // line-height: 16px;
          // opacity: 1;
        }
      }
      .rank-rule {
        position: absolute;
        right: 24px;
        top: 0;
        font-size: 12px;
        color: var(--theme-tab-content-rank-rule-font);
        &:hover {
          cursor: pointer;
        }
        .rank-icon:before {
          display: inline-block;
          width: 12px !important;
          height: 12px !important;
          font-size: 12px;
        }
      }
    }

    .rank-band {
      text-align: center;
      height: calc(100% - 66px);
      overflow-y: scroll;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        border-radius: 0;
        background-color: transparent;
      }
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }

      &::-webkit-scrollbar-thumb {
        height: 60px;
        border-radius: 10px;
        border: 1px solid #ccc;
        background-color: #ccc !important;
      }

      .rank-list-more {
        height: 20px;
        padding: 12px 0;
        text-align: center;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        color: #999;
      }

      .loading-bottom {
        width: 100%;
        height: 20px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: var(--theme-tab-content-rank-finish-font);
        line-height: 20px;
        margin-top: 10px;
      }
      img {
        width: 90%;
      }
      .band-list {
        width: 100%;
        height: 100%;
        user-select: none;
        &.noData {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            margin: 0;
          }
        }
      }
      .rank-item {
        width: 100%;
        height: 54px;
        box-sizing: border-box;
        line-height: 54px;
        font-size: 14px;
        color: #e6e6e6;
        text-align: left;
        border-bottom: 1px solid var(--theme-tab-content-rank-split-bg);
        position: relative;
        &:after {
          clear: both;
        }
        .rank-num {
          display: inline-block;
          width: 20px;
          height: 24px;
          margin-right: 6px;
          margin-top: 15px;
          line-height: 24px;
          text-align: center;
          vertical-align: top;
          position: relative;
        }

        .avatar {
          display: inline-block;
          width: 28px;
          height: 28px;
          margin-right: 10px;
          border-radius: 50%;
        }
        .top-three {
          width: 37px;
          height: 42px;
          position: relative;
          margin-right: 10px;
          margin-top: 6px;
          display: inline-block;
          .rank-num-wrap {
            position: absolute;
            top: 26%;
            left: 8%;
            width: 28px;
            height: 28px;
            border-radius: 100%;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              vertical-align: top;
            }
          }
        }
        .top-three-1 {
          background: url('../assets/imgs/list1.png') no-repeat;
          background-size: 37px 42px;
          background-position: center;
        }
        .top-three-2 {
          background: url('../assets/imgs/list2.png') no-repeat;
          background-size: 37px 42px;
          background-position: center;
        }
        .top-three-3 {
          background: url('../assets/imgs/list4.png') no-repeat;
          background-size: 35px 41px;
          background-position: 10% 5%;
        }
        .top-three-3 {
          width: 36px;
          height: 41px;
          img {
            top: 24%;
          }
        }
        .nickname {
          display: inline-block;
          width: 60%;
          text-align: left;
          vertical-align: top;
          color: var(--theme-tab-content-rank-content-font);
        }
        .num {
          // float: right;
          position: absolute;
          right: 0px;
          color: var(--theme-tab-content-rank-content-invite-font);
          .n {
            color: var(--theme-color);
          }
        }
      }
      .default-icon {
        width: 121px;
        height: 84px;
        display: inline-block;
        margin: 200px auto 0px;
      }
      .default-tip {
        font-size: 12px;
        color: var(--theme-tab-content-rank-noData-font);
        display: inline-block;
        width: 100%;
        text-align: center;
        margin-top: 10px;
      }
    }

    .self-rank {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      border-radius: 0 0 4px 4px;
      width: 100%;
      box-sizing: border-box;
      background-color: var(--theme-tab-content-rank-bottom-bg);

      &.is-scroll {
        max-width: 324px;
      }
    }

    .ranking-box {
      position: absolute;
      top: 26px;
      left: 0px;
      width: 100%;
      height: 184px;
      background: var(--theme-tab-content-rank-rule-content-bg);
      padding: 12px 24px;
      box-sizing: border-box;
      word-break: break-all;
      font-size: 12px;
      font-weight: 400;
      color: @font-dark-normal;
      line-height: 20px;
      text-align: left;
      overflow: auto;
      z-index: 10;
      box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.05), 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
      ::v-deep > p {
        width: 100%;
        height: 100%;
      }
      .rank-con {
        color: var(--theme-tab-content-rank-rule-content-font);
        width: 100%;
        word-break: break-word;
      }
      .center {
        text-align: center;
        line-height: 184px;
      }
    }
    .watch-area {
      width: 360px;
    }
  }
  .rank-preview-box {
    width: 480px;
    .ranking-box {
      width: 100%;
      left: 0px;
    }
  }
  .my_invite_detail {
    font-size: 12px;
    color: #0a7ff5;
  }
</style>
